// Features combined with placements as found in https://www.figma.com/design/c5JCpE4Fdh4B8SVt2xoOvB/Confluence%3A-Prompt-for-payment-on-paid-feautres
export const FEATURE_ID_PAGE_ANALYTICS_MODAL = 'itfg-bnr-page-analytics-modal';
export const FEATURE_ID_PAGE_ANALYTICS_PAGE = 'itfg-bnr-page-analytics-page';
export const FEATURE_ID_PAGE_RESTRICTIONS_MODAL = 'itfg-bnr-page-restrictions-modal';
export const FEATURE_ID_AUTOMATION_PAGE = 'itfg-bnr-automation-page';
export const FEATURE_ID_SPACE_ANALYTICS_PAGE = 'itfg-bnr-space-analytics-page';
export const FEATURE_ID_TEAM_CALENDAR_PAGE = 'itfg-bnr-team-calendar-page';
export const FEATURE_ID_USD_MODAL = 'itfg-bnr-usd-modal';

export const EDITION_PREMIUM = 'premium';
export const EDITION_STANDARD = 'standard';
